var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body flex" },
            [
              _c("date-range-picker", {
                ref: "picker",
                attrs: {
                  startDate: _vm.startDate,
                  opens: "right",
                  ranges: _vm.ranges,
                  "locale-data": _vm.date_locale,
                },
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "ml-1 mr-1" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.project,
                        expression: "project",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.project = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "all" } }, [
                      _vm._v("Все проекты"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.$AllProjects, function (project) {
                      return project.id
                        ? _c("option", { domProps: { value: project.id } }, [
                            _vm._v(_vm._s(project.name)),
                          ])
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "vue-ladda",
                {
                  attrs: {
                    "button-class": "btn btn-info",
                    "data-style": "zoom-in",
                    loading: _vm.btnLoading,
                  },
                  on: { click: _vm.showStatistics },
                },
                [_vm._v("Показать статистику\n          ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.total_orders
              ? _c("div", [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.income.delivery)),
                    ]),
                    _vm._v(": Курьерские"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.income.post)),
                    ]),
                    _vm._v(": Почтовые"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.total_orders.income.post +
                            _vm.total_orders.income.delivery
                        )
                      ),
                    ]),
                    _vm._v(": Всего за период"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            !_vm.loading
              ? _c(
                  "div",
                  [_c("highcharts", { attrs: { options: _vm.chartOptions } })],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.total_orders
              ? _c("div", [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.confirmed.delivery)),
                    ]),
                    _vm._v(": Курьерские"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.confirmed.post)),
                    ]),
                    _vm._v(": Почтовые"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.total_orders.confirmed.post +
                            _vm.total_orders.confirmed.delivery
                        )
                      ),
                    ]),
                    _vm._v(": Всего за период"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c("highcharts", {
                      attrs: { options: _vm.chartOptionsPayed },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.total_orders
              ? _c("div", [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.rejected.delivery)),
                    ]),
                    _vm._v(": Курьерские"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.rejected.post)),
                    ]),
                    _vm._v(": Почтовые"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.total_orders.rejected.post +
                            _vm.total_orders.rejected.delivery
                        )
                      ),
                    ]),
                    _vm._v(": Всего за период"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c("highcharts", {
                      attrs: { options: _vm.chartOptionsRejected },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _vm.total_orders
              ? _c("div", [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.delayed.delivery)),
                    ]),
                    _vm._v(": Курьерские"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.total_orders.delayed.post)),
                    ]),
                    _vm._v(": Почтовые"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.total_orders.delayed.post +
                            _vm.total_orders.delayed.delivery
                        )
                      ),
                    ]),
                    _vm._v(": Всего за период"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c("highcharts", {
                      attrs: { options: _vm.chartOptionsDelayed },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.reject_text
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _vm._v("\n          " + _vm._s(_vm.reject_text) + "\n        "),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }